<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item"><router-link to="/kr/mypage/favo/favoDoctors">관심 의료진</router-link></li>
            <li class="tab-menu__item active"><router-link to="/kr/mypage/favo/favoContents">관심 콘텐츠</router-link></li>
        </ul>
    </div>
    <div class="table-wrap">
        <div class="table-search">
            <div class="select">
                <a href="javascript:;" class="select--btn" :class="{ active: select01 }"  @click.prevent="activeselect01">{{selectedBoard}}</a>
                <slide-up-down :active="select01" class="select-option">
                    <a href="javascript:;" class="select-option--btn" @click="setInfo()">전체</a>
                    <a href="javascript:;" class="select-option--btn" @click="setInfo(board)" v-for="board in boardList[$store.state.hospStore.host]" :key="board">{{board.boardName}}</a>
                </slide-up-down>
            </div>
        </div>
        <div class="table board">
            <div class="table__inner">
                <table>
                    <colgroup>
                        <col style="width: 27%; ">
                        <col >
                        <col style="width: 17%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>구분</th>
                            <th>제목</th>
                            <th>관심설정</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="articleList.length == 0">
                            <td colspan="3">"등록한 관심콘텐츠가 없습니다."</td>
                        </tr>
                        <tr v-for="article in articleList" :key="article">
                            <td class="day">{{article.boardNo == '7' ? '질환 및 검사정보' : article.boardName}}</td>
                            <td class="title left">
                                <a href="javascript:;" @click="articleView(article)">{{article.articleTitle}}</a>
                            </td>
                            <td class="checkbox">
                                <kr_FavoHeart :info="favoInfo(article)" @getList="getList(this.searchBoardNo)"/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <kr_Pagination :totCnt="totCnt" :pageRow="pageRow" :currentNum="currentNum" :pageCount="pageCount" @setNum="setNum"/>
</template>

<script>
    import SlideUpDown from 'vue-slide-up-down';
    export default {
        components: {
            SlideUpDown,
        },
        data() {
            return {
                select01: false,

                orgList: [],
                articleList: [],
                searchBoardNo: '',
                selectedBoard: '전체',
                totCnt: 0,
                pageRow: 10,
                currentNum: this.$route.query.currentNum || 1,
                pageCount: 5,
                boardList: {
                    "H0006": [
                        {boardName: '질환 및 검사정보', boardNo: 7},
                        {boardName: '혈관E-이야기', boardNo: 12},
                        {boardName: '혈관 e-TV', boardNo: 13}
                    ],
                    "H0007": [
                        {boardName: '질환 및 검사정보', boardNo: 8},
                        {boardName: '혈관E-이야기', boardNo: 19},
                        {boardName: '혈관 e-TV', boardNo: 18}
                    ],
                    "H0008": [
                        {boardName: '출산준비교실', boardNo: 15}
                    ],
                    "H0009": [
                        {boardName: '혈액질환', boardNo: 29},
                        {boardName: '세포치료', boardNo: 30},
                        {boardName: '건강TV', boardNo: 27},
                        {boardName: '건강이야기', boardNo: 28}
                    ]
                }
            };
        },
        watch: {
            $route(to, from) {
                // 동일 게시판 안에서 이동
                if (to.query != from.query && to.path == from.path) {
                    if (Object.keys(to.query).length === 0) this.currentNum = 1
                    for (let i in this.$route.query) {
                        this[i] = this.$route.query[i]
                    }

                    this.getList()
                }
            },
        },
        methods: {
            activeselect01() {
                this.select01 = !this.select01;
            },
            getList(boardNo){
                let params = { 'favoTypeCd' : 'BBS' }

                this.searchBoardNo = ''
                if(boardNo){
                    this.searchBoardNo = boardNo
                }

                if(this.searchBoardNo){
                    params.boardNo = boardNo
                }

                this.axios({
                    method:"get",
                    url: this.api.favorite.list, 
                    params: params
                }).then(res => {
                    this.articleList = []
                    this.orgList = []
                    const list  = res.data.favoList
                    if(Array.isArray(list)){
                        this.orgList = list
                    }
                    this.$nextTick(() => {
                        this.sliceList()
                    })
                    this.totCnt = res.data.totCnt
                });
            },
            sliceList(){
                const start = (this.currentNum - 1) * this.pageRow
                const end = this.currentNum * this.pageRow
                this.articleList = this.orgList.slice(start, end)
            },
            favoInfo(info){
                const obj = {}
                obj.favoYn = 'Y'
                obj.no = info.articleNo
                obj.type = 'BBS'
                obj.mypageYn = true
                return obj
            },
            articleView(article){
                let url = `/kr/${article.boardId}/view?boardNo=${article.boardNo}&articleNo=${article.articleNo}`
                this.$router.push(url)
            },
            setNum(n) {
                this.currentNum = n
                this.goPage()
            },
            goPage() {
                const obj = { currentNum: this.currentNum, title: this.title, content: this.content, searchKeyword: this.searchKeyword };
                for (const key in obj) {
                    if (obj[key] === null || obj[key] === '') {
                        delete obj[key];
                    }
                }

                this.$router.push({ path: this.$route.path, query: obj });
            },
            // 데이터 초기화
            init() {
                this.currentNum = 1
            },
            setInfo(board){
                this.currentNum = 1
                this.selectedBoard = board ? board.boardName : '전체'
                this.getList(board ? board.boardNo : null)
                this.activeselect01()
            }
        },
        mounted() {
            this.getList()
        },
    }
</script>

<style scoped></style>